<template>
  <div :class="`${editable ? 'base-edit' : ''}`">
    <editor-menu-bar
      :editor="editor"
      v-if="editable"
      v-slot="{ commands, isActive }"
    >
      <div class="menubar">
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <v-icon x-small>fa-bold</v-icon>
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <v-icon x-small>fa-italic</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <v-icon x-small>fa-strikethrough</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <v-icon x-small>fa-underline</v-icon>
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          H1
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          H2
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          H3
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.heading({ level: 4 }) }"
          @click="commands.heading({ level: 4 })"
        >
          H4
        </v-btn>
        <v-btn depressed x-small @click="showImagesPrompt">
          <v-icon x-small>fa-image</v-icon>
        </v-btn>
        <v-btn depressed x-small @click="showVideoPrompt(commands.iframe)">
          <v-icon x-small>fa-video</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.align({ textAlign: 'left' }) }"
          @click="commands.align({ textAlign: 'left' })"
        >
          <v-icon x-small>fa-align-left</v-icon>
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.align({ textAlign: 'center' }) }"
          @click="commands.align({ textAlign: 'center' })"
        >
          <v-icon x-small>fa-align-center</v-icon>
        </v-btn>
        <v-btn
          depressed
          x-small
          :class="{ 'is-active': isActive.align({ textAlign: 'right' }) }"
          @click="commands.align({ textAlign: 'right' })"
        >
          <v-icon x-small>fa-align-right</v-icon>
        </v-btn>
        <v-btn depressed x-small @click="commands.ordered_list">
          <v-icon x-small>fa-list-ol</v-icon>
        </v-btn>
        <v-btn depressed x-small @click="commands.bullet_list">
          <v-icon x-small>fa-list</v-icon>
        </v-btn>

        <v-btn depressed x-small @click="commands.undo">
          <v-icon x-small>fa-undo</v-icon>
        </v-btn>

        <v-btn depressed x-small @click="commands.redo">
          <v-icon x-small>fa-redo</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          @click="commands.textcolor({ color: '#cc8556' })"
        >
          <v-icon x-small style="color: #cc8556;">fa-font</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          @click="commands.textcolor({ color: '#35606f' })"
        >
          <v-icon x-small style="color: #35606f;">fa-font</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          @click="commands.textcolor({ color: '#4f4f4f' })"
        >
          <v-icon x-small style="color: #4f4f4f;">fa-font</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          @click="commands.textcolor({ color: '#3c807e' })"
        >
          <v-icon x-small style="color: #3c807e;">fa-font</v-icon>
        </v-btn>

        <v-btn
          depressed
          x-small
          @click="commands.textcolor({ color: '#b3b3b3' })"
        >
          <v-icon x-small style="color: #b3b3b3;">fa-font</v-icon>
        </v-btn>

        <v-overlay :value="videoOverlay" class="d-flex" opacity="0.5">
          <v-card light max-width="850" min-width="650" elevation="4">
            <v-card-title>YouTube embed code</v-card-title>
            <v-card-text>
              <v-text-field
                outlined
                dense
                id="js-video-url"
                v-model="videoUrl"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="x-small default-action-btn"
                @click="addVideoLink(commands.iframe)"
                >add</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                class="dangerous-action-btn mr-4 mt-n4"
                @click="videoOverlay = false"
              >
                cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-overlay>

        <v-overlay :value="overlay" class="d-flex" opacity="0.5">
          <v-card light elevation="4">
            <v-card-text>
              <v-card
                class="ma-2"
                light
                max-width="850"
                min-width="650"
                outlined
              >
                <v-card-title>Public Image URL</v-card-title>
                <v-card-text>
                  <div class="image-link">
                    <v-text-field
                      outlined
                      dense
                      id="js-image-url"
                      v-model="imageUrl"
                    ></v-text-field>
                    <v-btn
                      class="x-small default-action-btn"
                      @click="addImageLink(commands.image)"
                      >add</v-btn
                    >
                  </div>
                </v-card-text>
              </v-card>
              <v-card
                class="ma-2"
                light
                max-width="850"
                min-width="650"
                outlined
              >
                <v-card-title>Upload Local Image</v-card-title>
                <v-card-text>
                  <div class="documentUploader">
                    <v-file-input
                      v-on:change="fileSelected"
                      v-model="files"
                      label="Document Upload"
                    ></v-file-input>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    class="default-action-btn"
                    v-on:click="encodeFile(commands.image)"
                    >Embed</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="dangerous-action-btn mr-4 mt-n4"
                @click="overlay = false"
              >
                cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-overlay>
      </div>
    </editor-menu-bar>
    <editor-content
      :class="editable ? 'editor__content edit' : 'editor__content'"
      :editor="editor"
    />
    <v-btn
      @click="
        fireEvent('editor:update', editor.getHTML())
        dirty = false
      "
      v-if="editable"
      :disabled="editor.getHTML().length > maxCharacters"
      class="save"
      >Save</v-btn
    >
    <span
      class="body-size-warning"
      v-if="editable && editor.getHTML().length > maxCharacters"
      >Content is {{ editor.getHTML().length - maxCharacters }} characters too
      large to save!</span
    >
  </div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap"
import {
  Bold,
  BulletList,
  Code,
  HardBreak,
  Heading,
  History,
  Image,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Strike,
  Underline
} from "tiptap-extensions"
import Alignment from "@/tiptap-extensions/Alignment"
import Iframe from "@/tiptap-extensions/Iframe"
import eventMixin from "@/mixins/eventMixin"
import TextColor from "@/lib/TextColor"

export default {
  mixins: [eventMixin],
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    editable: { type: Boolean, default: false },
    content: { type: String, default: "</br></br>" }
  },
  watch: {
    content: function(val) {
      this.editor.setContent(val)
    }
  },
  mounted() {
    this.editor.setContent(this.content)
    this.$router.beforeEach((to, from, next) => {
      if (this.dirty) {
        const leave = confirm(
          "You have unsaved changes.\n\nAre you sure you want to leave this page?"
        )
        if (leave) {
          this.dirty = false
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    })
  },
  data() {
    var that = this
    return {
      file: {},
      files: [],
      imageUrl: "",
      videoUrl: "",
      maxCharacters: 16777215,
      overlay: false,
      videoOverlay: false,
      dirty: false,
      editor: new Editor({
        onUpdate: function(state) {
          that.dirty = true
        },
        editable: this.editable,
        extensions: [
          new Alignment(),
          new Bold(),
          new BulletList(),
          new Code(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4] }),
          new History(),
          new Image(),
          new Italic(),
          new Iframe(),
          new Link(),
          new ListItem(),
          new OrderedList(),
          new Strike(),
          new Underline(),
          new TextColor()
        ]
      })
    }
  },
  methods: {
    showImagesPrompt() {
      this.overlay = true
    },
    fileSelected(File) {
      this.file = File
    },
    encodeFile(command) {
      const reader = new FileReader()
      const b64 = reader.readAsDataURL(this.file)
      reader.addEventListener(
        "load",
        function() {
          const src = reader.result
          command({ src })
        },
        false
      )

      this.file = {}
      this.files = []
      this.overlay = false
    },
    addImageLink(command) {
      const src = this.imageUrl
      command({ src })
      this.overlay = false
    },
    addVideoLink(command) {
      const embedCode = this.videoUrl

      let match = embedCode.match(
        /width=\"(.*?)\" height=\"(.*?)\" src=\"(.*?)\"/
      )

      if (match && match.length === 4) {
        let width = parseFloat(match[1])
        let height = parseFloat(match[2])
        const ratio = width / height

        width = Math.floor(650)
        height = Math.floor(650 / ratio)

        const newCode = `width:${width}px; height:${height}px;`

        command({
          style: newCode,
          src: match[3]
        })
      } else {
        command({
          src: embedCode,
          allowFullscreen: true
        })
      }
      this.videoOverlay = false
    },
    showVideoPrompt() {
      this.videoOverlay = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

div.menubar {
  border-width: 1px 1px 0 1px;
  border-style: solid;
  border-color: $light-grey;
}
div.edit {
  border-width: 1px;
  border-style: solid;
  border-color: $light-grey;
}
button.save {
  background-color: $dark-blue !important;
  border-radius: 25px;
  color: $white !important;
  font-style: italic;
  margin-top: 5px;
}
.is-active {
  background-color: $light-grey !important;
}

.iframe {
  &__embed {
    width: 100%;
    border: 0;
  }
  &__input {
    display: block;
    width: 100%;
    font: inherit;
    border: 0;
    border-radius: 5px;
    background-color: rgba(black, 0.1);
    padding: 0.3rem 0.5rem;
  }
}

.v-btn {
  margin: 1px !important;
  border: 1px solid #999 !important;
}

.body-size-warning {
  color: $orange;
}
</style>
